import React from 'react';
import { forNamespace } from 'app/common/lib/util/i18n';
import {
  CardTemplatesPopover,
  CreateCardFromTemplatePopover,
  KeepFromSourceTypes,
} from 'app/src/components/CardTemplatesPopover';

const PopOver = require('app/scripts/views/lib/pop-over');
const format = forNamespace('view title');

export const toggleCardTemplatesPopover = ({
  elem,
  idList,
  idBoard,
  createCard,
}: {
  elem: Element;
  idList: string;
  idBoard: string;
  createCard: (
    name: string,
    idCardSrouce: string,
    keepFromSource: KeepFromSourceTypes[],
  ) => Promise<void>;
}) => {
  const onCardTemplateSelect = (idCard: string) => {
    PopOver.pushView({
      elem,
      getViewTitle: () => format('create card'),
      reactElement: React.createElement(CreateCardFromTemplatePopover, {
        key: 'create-card-from-template',
        idCard,
        createCard,
      }),
    });
  };

  PopOver.toggle({
    elem,
    displayType: 'mod-card-templates',
    getViewTitle: () => format('card templates beta'),
    reactElement: React.createElement(CardTemplatesPopover, {
      key: 'card-template-list',
      idList,
      idBoard,
      onSelect: onCardTemplateSelect,
    }),
  });
};
